import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Product } from '@platform-frontend/marketplace';

@UntilDestroy()
@Component({
  selector: 'yat-solution-download',
  templateUrl: './solution-download.component.html',
  styleUrls: ['./solution-download.component.scss']
})
export class SolutionDownloadComponent {
  @Input()
  product: Product | null;

  getDownloadOverviewPath(): string {
    return this.product?.productPaths.find(path => path.type === 'DOWNLOAD_PAGE')?.url ?? '';
  }
}
